// Utility functions for formatting

/**
 * Format a quantity to max 2 decimal places
 * Shows as whole number if .00
 * @param {number} value - The quantity to format
 * @returns {string} Formatted quantity
 */
export const formatQuantity = (value) => {
  if (value === null || value === undefined) return '-';
  const num = parseFloat(value);
  if (isNaN(num)) return '-';
  
  // Check if it's a whole number
  if (num === Math.floor(num)) {
    return num.toString();
  }
  
  // Round to 2 decimal places and remove trailing zeros
  const formatted = num.toFixed(2);
  return formatted.replace(/\.?0+$/, '') || '0';
};

/**
 * Format cost to 2 decimal places with £ symbol
 * @param {number} value - The cost to format
 * @returns {string} Formatted cost
 */
export const formatCost = (value) => {
  if (value === null || value === undefined) return '£0.00';
  return `£${parseFloat(value).toFixed(2)}`;
};

/**
 * Format cost per unit to 4 decimal places with £ symbol
 * @param {number} value - The cost per unit to format
 * @returns {string} Formatted cost per unit
 */
export const formatCostPerUnit = (value) => {
  if (value === null || value === undefined) return '£0.0000';
  return `£${parseFloat(value).toFixed(4)}`;
};

/**
 * Format cost per 100g
 * @param {number} costPerUnit - The cost per unit (g)
 * @returns {string} Formatted cost per 100g
 */
export const formatCostPer100g = (costPerUnit) => {
  if (costPerUnit === null || costPerUnit === undefined) return '-';
  return `£${(parseFloat(costPerUnit) * 100).toFixed(2)}`;
};
